import { atom } from 'jotai'
import { Genre } from '../../Api/Lirari/Types/genre'
import { Offering } from '../../Api/Lirari/Types/offering'
import { Skill } from '../../Api/Lirari/Types/skill'
import { PortfolioLink } from '../../Api/Lirari/Types/portfolioLinks'

export const unauthenticatedUserAtom = atom({
  id: '',
  auth0Id: '',
  firstName: '',
  lastName: '',
  email: '',
  about: '',
  locationFormattedString: '',
  socialLinks: { youtube: '', spotify: '', soundCloud: '' },
  userSkills: [] as Skill[],
  userGenres: [] as { genre: Genre }[],
  userOfferings: [] as { offering: Offering }[],
  profileImageUrl: '',
  portfolioLinks: [] as PortfolioLink[],
  profileAudioUrl: '',
})
